// extracted by mini-css-extract-plugin
module.exports = {"productDetail":"YmrSOAoB","topWrap":"KIXKwBPR","leftWrap":"mjHXKxg6","rightWrap":"TKVU4ExK","topWrapNew":"VTTuvn10"};